<template>
  <div class="w-full">
    <div class="grid col-1 md-col-2 w-full mb-0">
      <InputField
        v-model="leadForm.firstName"
        type="text"
        left-icon-class="icon-users"
        right-icon-class="icon-close input__right-icon--hover"
        :label="$t('first_name')"
        :has-error="v$.firstName.$invalid && v$.firstName.$anyDirty"
        :has-right-reset-button="true"
        @on-right-click="leadForm.firstName = ''"
      />

      <InputField
        v-model="leadForm.lastName"
        type="text"
        left-icon-class="icon-users"
        right-icon-class="icon-close input__right-icon--hover"
        :label="$t('last_name')"
        :has-error="v$.lastName.$invalid && v$.lastName.$anyDirty"
        :has-right-reset-button="true"
        @on-right-click="leadForm.lastName = ''"
      />
    </div>

    <InputField
      v-model="leadForm.email"
      type="text"
      left-icon-class="icon-mail-envelope"
      right-icon-class="icon-close input__right-icon--hover"
      :label="$t('email')"
      :has-error="v$.email.$invalid && v$.email.$anyDirty"
      :has-right-reset-button="true"
      @on-right-click="leadForm.email = ''"
    />

    <div v-if="languages" class="mb-24">
      <SelectField
        id="leadFormLang"
        v-model="leadForm.language"
        :options="languages"
        value-prop-name="locale"
        :placeholder="$t('select_your_language')"
        icon-class-left="icon-lang"
        icon-class-right="icon-simple-arrow-down"
        :has-error="v$.language.$invalid && v$.language.$anyDirty"
        @change="onLanguageChange"
      />
    </div>
    <button
      class="btn btn--purple"
      :class="{ 'btn--loading': isLoading }"
      :disabled="v$.$invalid"
      type="button"
      @click="sendLead"
    >
      <template v-if="isLoading">
        <LoadingDots />
      </template>
      <template v-else>
        {{ $t('inform_me') }}
        <span class="icon-simple-arrow-right btn__icon"></span>
      </template>
    </button>
  </div>
</template>

<script setup>
import { LoadingDots } from '@snowshoe-frontend/shared-components'
import {
  InputField,
  SelectField
} from '@snowshoe-frontend/form-fields-components'
import { reactive } from 'vue'
import useVuelidate from '@vuelidate/core'
import { useLanguages } from '@/composables/useLanguages.js'
import { useCommonStore } from '@/stores/commonStore'
import { storeToRefs } from 'pinia'
import createLeadSchema from '@/openapi-schemas/create_lead.json'
import { schemaToValidators } from '@snowshoe-frontend/utils-component'

defineProps({
  isLoading: {
    type: Boolean,
    default: false
  }
})

const emit = defineEmits(['sendLead'])

const leadForm = reactive({
  language: '',
  firstName: '',
  lastName: '',
  email: ''
})

const { changeLanguage } = useLanguages()

const commonStore = useCommonStore()
const { languages } = storeToRefs(commonStore)

const rules = {
  ...schemaToValidators(createLeadSchema)
}

const v$ = useVuelidate(rules, leadForm, { $autoDirty: true })

const sendLead = () => {
  emit('sendLead', leadForm)
}

const onLanguageChange = async () => {
  const language = languages.value.find(
    (lang) => lang.locale === leadForm.language
  )

  if (!language) return

  await changeLanguage(language.locale.split('_')[0])
}
</script>
